import { message } from "antd";
import { useState } from "react";
import { changeHouseCommand, changeHouseCommandAD, changeHousePriority } from "../../../../api/api";

const RecommendAD = (props) => {
  // console.log('recommend info',props);
  // const [isRecommend, setIsRecommend] = useState(props.is_recommend)
  const { id, setIsFresh,value } = props;
  const changeStatus = () => {
    changeHouseCommandAD(id, Number(!value)).then((res) => {
      console.log(id, value);
      value === 0
        ? message.success("成功在广告活动中进行推荐")
        : message.success("已取消在广告活动中进行推荐");
      setIsFresh((pre) => {
        console.log("fresh!", pre);
        return !pre;
      });
    });
  };
  return (
    <div>
      <a onClick={changeStatus}>{value === 0 ? "广告推荐" : "取消广告"}</a>
    </div>
  );
};

export default RecommendAD;
